import { render, staticRenderFns } from "./VectraitsDataset.vue?vue&type=template&id=46ed706a&"
import script from "./VectraitsDataset.vue?vue&type=script&lang=js&"
export * from "./VectraitsDataset.vue?vue&type=script&lang=js&"
import style0 from "./VectraitsDataset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports